import { React, useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./login.css";
import { Redirect, Link, useHistory } from "react-router-dom";
import httpService from "../../services/http.service";
import { FaUser } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import loginImg from "../../assets/loginleft.png";
import "react-toastify/dist/ReactToastify.css";
import WarningMessage from "../common/warnMsg";
import ErrorMessage from "../common/errorMsg";
import SuccessMessage from "../common/successMsg";

let ForgetPassword = (props) => {
    const history = useHistory();
    const [customerId, setCustomerId] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [token, setToken] = useState("")
    const [otp, setOtp] = useState("")
    const [activeTab, setActiveTab] = useState("customer_id")

    const sendOTPHandler = async (e) => {
        e.preventDefault()
        try {
            let { data } = await httpService.CreateUpdate("forget-password", { customerId })
            if (data.ack === "0") {
                return WarningMessage(data.message)
            }

            SuccessMessage(data.message)
            setToken(data.token)
            setActiveTab("OTP")
        } catch (error) {
            ErrorMessage("Something went wrong!")
        }
        console.log("sendOTPHandler")
    }

    const resetState = () =>{
        setCustomerId("")
        setNewPassword("")
        setConfirmPassword("")
        setOtp("")
        setActiveTab("customer_id")
        history.push("/")
    }

    const verifyHandler = async (e) => {
        e.preventDefault()
        try {
            const { data } = await httpService.CreateUpdate("verify-otp", { token, OTP: otp })
            if (data.ack === "0") {
                return WarningMessage(data.message)
            }
            setActiveTab("Change_Password")
        } catch (error) {
            ErrorMessage("Something went wrong!")
        }

    }

    const changePasswordHandler = async (e) => {
        e.preventDefault()

        if (newPassword !== confirmPassword) {
            return WarningMessage("Password not matched")
        }
        try {
            const { data } = await httpService.CreateUpdate("change-password", { token, password: newPassword })

            if (data.ack === "0") {
                return WarningMessage(data.message)
            }

            SuccessMessage(data.message)
            
            resetState()
        } catch (error) {
            ErrorMessage("Something went wrong!")
        }
    }


    return (
        <div>
            <div className="home-btn d-none d-sm-block">
                <i className="bx bx-home h2"></i>
            </div>
            <div className="account-pages">
                <Container>
                    <Row className="justify-content-center">
                        <Col md={12} lg={11} xl={8}>
                            <Card className="overflow-hidden login-wrapper">
                                <CardBody className="row">
                                    <div className="col-6 p-0">
                                        <div className="login-img">
                                            <img src={loginImg} alt="LoginImage" />
                                        </div>
                                    </div>
                                    <div className="col-6 p-0">
                                        <div className="login-right">
                                            <div className="login-txthead">Cloud User Forget Password</div>
                                            <p className="signText">
                                                Forget Password to continue to RSD.
                                            </p>
                                            <div className="">
                                                <form
                                                    onSubmit={activeTab === "customer_id" && sendOTPHandler || activeTab === "OTP" && verifyHandler || activeTab === "Change_Password" && changePasswordHandler}
                                                    className="form-horizontal login-form"
                                                    autoComplete="off"
                                                >
                                                    {activeTab === "customer_id" && <div className="form-group">
                                                        <FaUser style={{ position: "absolute", top: 13, left: 4 }} color="#8B8680" />
                                                        <input
                                                            name="customerId"
                                                            type="text"
                                                            className="form-control formInput"
                                                            value={customerId}
                                                            placeholder="Account Name"
                                                            onChange={(e) => setCustomerId(e.target.value )}
                                                            autoComplete="off"
                                                        />
                                                    </div>}
                                                    {activeTab === "OTP" && <div className="form-group">
                                                        <RiLockPasswordFill style={{ position: "absolute", top: 13, left: 4 }} color="#8B8680" />
                                                        <input
                                                            name="otp"
                                                            type="text"
                                                            className="form-control formInput"
                                                            value={otp}
                                                            placeholder="OTP"
                                                            onChange={(e) => setOtp(e.target.value)}
                                                            autoComplete="off"
                                                        />
                                                    </div>}

                                                    {activeTab === "Change_Password" && <>
                                                        <div className="form-group">
                                                            <RiLockPasswordFill style={{ position: "absolute", top: 13, left: 4 }} color="#8B8680" />
                                                            <input
                                                                name="newPassword"
                                                                type="password"
                                                                className="form-control formInput"
                                                                value={newPassword}
                                                                placeholder="New Password"
                                                                onChange={(e) => setNewPassword(e.target.value)}
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <RiLockPasswordFill style={{ position: "absolute", top: 13, left: 4 }} color="#8B8680" />
                                                            <input
                                                                name="confirmPassword"
                                                                type="password"
                                                                className="form-control formInput"
                                                                value={confirmPassword}
                                                                placeholder="Confirm Password"
                                                                onChange={(e) => setConfirmPassword(e.target.value)}
                                                                autoComplete="off"
                                                            />
                                                        </div>
                                                    </>}
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            alignItems: "center",
                                                            justifyContent: "center",
                                                            gap: 2,
                                                            marginTop: 10,
                                                        }}
                                                    >
                                                        <div className="" style={{ width: "100%" }}>
                                                            <button
                                                                className="btn btn-primary"
                                                                type="submit"
                                                                disabled={
                                                                    (activeTab === "customer_id" && !customerId) ||
                                                                    (activeTab === "OTP" && !otp) ||
                                                                    (activeTab === "Change_Password" && (!newPassword || !confirmPassword))
                                                                }
                                                            >
                                                                {activeTab === "customer_id" && "Send OTP" ||
                                                                    activeTab === "OTP" && "Verify OTP" ||
                                                                    activeTab === "Change_Password" && "Submit"}
                                                            </button>
                                                        </div>
                                                        <div style={{ fontSize: 17 }}>OR</div>
                                                        <div className="" style={{ width: "100%" }}>
                                                            <div
                                                                className="btn btn-primary"
                                                                style={{ backgroundColor: "#48a942" }}
                                                                onClick={(e) => {
                                                                    history.push("/");
                                                                }}
                                                            >
                                                                Back to Sign in
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    );
};

export default ForgetPassword;
